import type { DataNotification } from '~/presentation/common';
import type { ICampaignIssue } from '~/modules/campaign';

import { GNotificationList, useGNotificationContext } from '~/presentation/common';
import { useCallback } from 'react';

const NOTICE_VALIDATE_PRESET: DataNotification = {
  id: 'notification-validation-error',
  tone: 'critical',
  condition: true,
};

export const useNotificationHandler = () => {
  const { removeNotificationById, handleSetNotification } = useGNotificationContext();

  const showNotification = useCallback(
    (issues: ICampaignIssue[]) => {
      const title = `There ${issues.length > 1 ? 'are' : 'is'} ${issues.length} error${issues.length > 1 ? 's' : ''} with this campaign`;
      const data = issues.map((item) => ({ content: item.message }));
      const children = GNotificationList({ data });
      handleSetNotification({ ...NOTICE_VALIDATE_PRESET, title, children });
    },
    [handleSetNotification],
  );

  const hideNotification = () => {
    removeNotificationById(NOTICE_VALIDATE_PRESET.id);
  };

  return { showNotification, hideNotification };
};
